import { useSettings } from "../context/SettingsContext";
import NotFound from "../pages/NotFound";

export const PageGate = ({ page, children }) => {
    const { settings } = useSettings();
    return (settings.hidden_pages || []).includes(page) ? <NotFound /> : children;
};
